import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";

import Login from "../pages/login"; //店铺登录
import ServicerLogin from "../pages/servicerLogin"; //服务商的公路
import Zhuce from "../pages/zhuce"; //注册
import PersonZhuce from "../pages/personZhuce"; //用户注册
import Retrieve from "../pages/retrieve"; //密码找回
import Error from "../pages/error"; //错误页面
import NotFound from "../pages/notfound"; //错误页面
import Success from "../pages/success"; //成功页面
import Home from "../pages/home"; //主页面
import Welcome from "../pages/welcome"; //欢迎页
import Register from "../pages/register"; //注册业
import ShangPin from "../pages/shangpinxinxi.vue"; //商品设置价格页面
import downLoad from "../pages/downLoad.vue"; //下载页面
import tigerzzVideo from "../pages/tigerzzVideo.vue"; //泰格视频
/* import Vendor from '../pages/people/vendor'
import God from '../pages/people/god' */

/* serve 服务商 */

import MyCard from "../pages/serve/pages/vip/myCard"; //新建会员卡
import Vip from "../pages/serve/pages/vip/vip"; //修改会员卡内容
import CardCantent from "../pages/serve/pages/vip/cardCantent"; //一键开卡 字段设置
import GetCode from "../pages/serve/pages/vip/getCode"; //领卡二维码
import Feed from "../pages/serve/pages/basic/feed"; //商户进件
import Log from "../pages/serve/pages/basic/log"; //日志页面
import CreateMerchant from "../pages/serve/pages/basic/createMerchant"; //创建店铺
// import Shome from "../pages/serve/pages/shome";//
import Sinformation from "../pages/serve/pages/basic/sinformation"; //服务商信息
import Advertised from "../pages/serve/pages/basic/advertised"; //
import ChangeBank from "../pages/serve/pages/basic/changeBank"; //绑定银行修改
import UserGroup from "../pages/serve/pages/people/userGroup"; //用户组
import Permission from "../pages/serve/pages/people/permission"; //所有权限
import SonService from "../pages/serve/pages/basic/sonService"; //子服务商
import Goodsinfo from "../pages/serve/pages/basicgoodsinfo/goodsInfo"; //商品基本库
import OnlineBaseClassInfo from "../pages/serve/pages/basicgoodsinfo/onlinebaseclassinfo.vue"; //
import ShopManage from "../pages/serve/pages/shop/shopmanage"; //查询店铺 （老）
import UnderInfo from "../pages/serve/pages/shop/underinfo"; //所有门店 版本和ip信息
import ServiceSwift from "../pages/serve/pages/paySet/serviceSwift"; //服务商配置swift //
import SwiftConfigure from "../pages/serve/pages/paySet/swiftConfigure"; //配置店铺威富通信息

/* 店铺 */ import Information from "../pages/shop/pages/store/information"; //店铺基本信息
import WxPayInfo from "../pages/shop/pages/store/wxPayInfo"; //店铺基本信息
import Peopleinfo from "../pages/shop/pages/set/peopleinfo"; //用户授权
import shopPermission from "../pages/shop/pages/set/shoppermission"; //所有权限
// import Shopinfo from '../pages/shop/set/shopinfo'//
import CreateCoupons from "../pages/shop/pages/vip/createCoupons"; //
import CreateActive from "../pages/shop/pages/vip/createActive"; //
import SetVipPermission from "../pages/shop/pages/vip/setVipPermission"; // 电子会员请求
import AllVip from "../pages/shop/pages/vip/allvip"; //所有会员

// import ShopHome from "../pages/shop/pages/shopHome";
import CreateCardClass from "../pages/shop/pages/vip/createCardClass"; //创建卡类别
import DrawTemplate from "../pages/shop/pages/platform/drawtemplate"; //标价签模板
import InSheet from "../pages/shop/pages/warehouse/insheet"; //入库
import OutSheet from "../pages/shop/pages/warehouse/outsheet"; //出库
import Business from "../pages/shop/pages/business/business"; //
import MUserGroup from "../pages/shop/pages/set/muserGroup"; //用户组

/* 用户 */
import PeopleHome from "../pages/people/pages/peoplehome";
import ReportWare from "../pages/people/pages/warehouse/reportware";
import Classinfo from "../pages/shop/pages/baseinfo/classInfo";
import Supplier from "../pages/shop/pages/baseinfo/supplier";
import CreateContract from "../pages/people/pages/cooperate/createContract";
import Collection from "../pages/people/pages/cooperate/collection";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "404",
      component: () =>
        import(/* webpackChunkName: "error404" */ "../pages/notfound")
    },
    { path: "/", redirect: "/login" },
    { path: "/login", name: "login", component: Login },
    { path: "/shangpin", name: "shangpin", component: ShangPin },
    { path: "/servicerlogin", name: "servicerlogin", component: ServicerLogin },
    { path: "/personZhuce", name: "personZhuce", component: PersonZhuce },
    { path: "/error", name: "error", component: Error },
    { path: "/notfound", name: "notfound", component: NotFound },
    { path: "/success", name: "success", component: Success },
    { path: "/zhuce", name: "zhuce", component: Zhuce },
    { path: "/retrieve", name: "retrieve", component: Retrieve },
    { path: "/register", name: "register", component: Register },
    { path: "/download", name: "download", component: downLoad },
    // { path: "/account/register", name: "register", component: Error },

    {
      path: "/home",
      component: Home,
      redirect: "/welcome",
      children: [
        { path: "/welcome", name: "welcome", component: Welcome },
        { path: "/peopleinfo", name: "peopleinfo", component: Peopleinfo },
        {
          path: "/shoppermission",
          name: "shoppermission",
          component: shopPermission
        },

        { path: "/musergroup", name: "usergroup", component: MUserGroup },
        { path: "/underinfo", name: "underinfo", component: UnderInfo },
        // { path: '/shopinfo', name: 'shopinfo', component: Shopinfo },
        { path: "/information", name: "information", component: Information },
        { path: "/wxPayInfo", name: "wxPayInfo", component: WxPayInfo },
        {
          path: "/swiftConfigure",
          name: "swiftConfigure",
          component: SwiftConfigure
        },

        
        {
          path: "/tigerzzvideo",
          name: "tigerzzvideo",
          component: tigerzzVideo
        },

        {
          path: "/createCoupons",
          name: "createCoupons",
          component: CreateCoupons
        },
        {
          path: "/CreateActive",
          name: "CreateActive",
          component: CreateActive
        },
        {
          path: "/setVipPermission",
          name: "setVipPermission",
          component: SetVipPermission
        },

        {
          path: "/CreateCardClass",
          name: "CreateCardClass",
          component: CreateCardClass
        },

        { path: "/business", name: "business", component: Business },
        { path: "/insheet", name: "insheet", component: InSheet },
        { path: "/outsheet", name: "outsheet", component: OutSheet },
        { path: "/userGroup", name: "userGroup", component: UserGroup },
        { path: "/permission", name: "permission", component: Permission },
        { path: "/feed", name: "feed", component: Feed },
        { path: "/log", name: "log", component: Log },
        {
          path: "/createMerchant",
          name: "createMerchant",
          component: CreateMerchant
        },
        {
          path: "/serviceSwift",
          name: "serviceSwift",
          component: ServiceSwift
        },

        { path: "/sonService", name: "sonService", component: SonService },
        {
          path: "/drawtemplate",
          name: "drawtemplate",
          component: DrawTemplate
        },
        {
          path: "/onlinebaseclassinfo",
          name: "onlinebaseclassinfo",
          component: OnlineBaseClassInfo
        },

        { path: "/shopmanage", name: "shopmanage", component: ShopManage },
        { path: "/sinformation", name: "sinfomation", component: Sinformation },
        { path: "/advertised", name: "advertised", component: Advertised },
        { path: "/vip", name: "vip", component: Vip },
        { path: "/allvip", name: "allvip", component: AllVip },
        { path: "/getCode", name: "getCode", component: GetCode },
        { path: "/cardCantent", name: "cardCantent", component: CardCantent },

        { path: "/changeBank", name: "changeBank", component: ChangeBank },
        { path: "/MyCard", name: "MyCard", component: MyCard },
        { path: "/reportware", name: "reportware", component: ReportWare },
        { path: "/goodsInfo", name: "goodsInfo", component: Goodsinfo },
        { path: "/classInfo", name: "classInfo", component: Classinfo },
        { path: "/supplier", name: "supplier", component: Supplier },

        {
          path: "/createContract",
          name: "createContract",
          component: CreateContract
        },
        { path: "/collection", name: "collection", component: Collection }
        // { path: '/reportware', name: 'reportware', component: ReportWare },
      ]
    }
    /* {
            path: '/shome',
            component: Shome,
            redirect: '/feed',
            children: [
                

            ]
        },
        {
            path: '/peoplehome',
            component: PeopleHome,
            redirect: '/reportware',
            children: [
                
            ]
        }, */
  ]
});

// 挂载路由导航守卫
// to   将要访问的路径
// from 代表从哪个路跳转来
// next 是一个函数表示放行
// next() 放行 next('/login')强制跳转
/* router.beforeEach((to, from, next) => {
  if (to.fullPath != store.state.home.editableTabsValue) {
    next(store.state.home.editableTabsValue);
  }
  next();
}); */

// 全局路由守卫
/*router.beforeEach((to, from, next) => {
    // to: Route: 即将要进入的目标 路由对象
    // from: Route: 当前导航正要离开的路由
    // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    const nextRoute = ['business', 'classInfo', 'goodsInfo', 'information', 'peopleInfo', 'personal', 'in', 'out', 'god', 'vendor', 'welcome'];
    // let isLogin=localStorage.getItem('token');
    let account_id = window.sessionStorage.getItem("account_id");
    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    console.log(nextRoute.indexOf(to.name));
    if (nextRoute.indexOf(to.name) >= 0 && !account_id) {
        next({
            path: '/login',
            // 将跳转的路由path作为参数，登录成功后跳转到该路由
            // query: { redirect: to.fullPath }
        })
    } else {
        next();
    }
    console.log(to.name);
    // 已登录状态；当路由到login时，跳转至home
    if (to.name === 'login' || to.name === 'zhuce' || to.name === 'personZhuce') {
        if (account_id) {
            console.log('已登录');
            router.push({ path: 'home' });
        }
    }

});*/

export default router;
